import React, { useState } from "react";
import { LegalModal } from "./LegalModal";
import { legalDocs, LegalDoc } from "../data/legal";
export function Footer() {
  const [doc, setDoc] = useState<LegalDoc | null>(null);
  return <footer className="border-t border-white/10 bg-cocoa-dark px-5 py-10 text-center text-xs leading-relaxed text-cream/50" data-id="element-64" data-mp="32onll67cnuaj">
      <nav aria-label="Legal" className="flex items-center justify-center gap-3 text-sm font-semibold text-cream/80" data-id="element-65" data-mp="36pz9n7aks7gm">
        {legalDocs.map((d, i) => <React.Fragment key={d.id} data-id="element-66" data-mp="39922nzchmct" data-mpi={i}>
            {i > 0 && <span aria-hidden className="text-cream/30" data-id="element-67" data-mp="37xx4ku5y8k4">;</span>}
            <button type="button" onClick={() => setDoc(d)} className="underline-offset-4 transition-colors duration-150 hover:text-gold-light hover:underline" data-id="element-68" data-mp="3lf5bl30ssbs7">
              {d.title}
            </button>
          </React.Fragment>)}
      </nav>
      <p className="mt-5" data-id="element-69" data-mp="2a1jm1gr10865">© {new Date().getFullYear()} Pack Dulce Saludable · Producto digital de descarga directa. Todos los derechos reservados.</p>
      <p className="mx-auto mt-3 max-w-2xl" data-id="element-70" data-mp="3lalhljipadw2">
        Este sitio no es parte de Facebook™ ni de Facebook Inc. Además, este sitio NO está respaldado por Facebook™ de ninguna manera. FACEBOOK™ es
        una marca registrada de FACEBOOK, Inc.
      </p>
      <p className="mx-auto mt-3 max-w-2xl" data-id="element-71" data-mp="3v5dfypk3x4rw">
        Este producto no sustituye el consejo médico profesional. Los resultados pueden variar de persona a persona. Consulta con tu médico o
        nutricionista ante cualquier condición de salud.
      </p>
      <LegalModal doc={doc} onClose={() => setDoc(null)} data-id="element-72" data-mp="32vyphf92q4z" />
    </footer>;
}